(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.elements.button.addEventListener('click', this.togglePanel.bind(this));
      this.addEventListener('keydown', this.onEscapePress.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    connectedCallback() {
      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    showPanel() {
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
    }

    togglePanel() {
      if (this.elements.button.getAttribute('aria-expanded') === 'true') {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onEscapePress(event) {
      if (event.key === 'Escape') {
        this.hidePanel();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
      this.hidePanel();
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.shopify-section-header');
        this.headerOverlay = document.querySelector('.header-overlay');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('always-fixed');
          if (!this.headerOverlay) {
            this.header.classList.add('shopify-section-header-sticky');
            this.headerOverlay.classList.add('color-background-1');
            this.headerOverlay.classList.remove('color-inverse');
          }
        }

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
          this.header.style.transform = 'translateY(-100%)';
        }

        if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
          this.header.classList.remove('color-background-2');
          this.header.style.transition = 'background var(--duration-short)';
          this.header.style.transform = 'translateY(0)';
        }

        if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
          this.header.style.transform = 'translateY(0)';
          this.header.style.transition = 'background var(--duration-short)';
          if (this.header.classList.contains('color-background-1')) {
            this.header.classList.add('color-background-2');
          }
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;

        if (document.querySelector('.search-modal.active')) return;
        if (document.querySelector('.burger-drawer.active')) {
          this.header.classList.remove('shopify-section-header-hidden', 'animate');
        }
        if (document.querySelector('.burger-drawer.active')) return;
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        if (this.headerOverlay) {
          this.headerOverlay.classList.add('color-background-1');
        }
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
        if (this.headerOverlay) {
          this.headerOverlay.classList.add('color-background-1');
          this.headerOverlay.classList.remove('color-inverse');
        }
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        if (this.headerOverlay) {
          this.headerOverlay.classList.remove('color-background-1');
          if (!this.classList.contains('mega-menu-open')) {
            this.headerOverlay.classList.add('color-inverse');
          }
        }
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        if (this.disclosures) {
          this.disclosures.forEach((disclosure) => {
            disclosure.close();
          });
        }
        this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
        if (this.disclosureLists) {
          this.disclosureLists.forEach((disclosureList) => {
            disclosureList.setAttribute('hidden', true);
          });
        }
        this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
        if (this.disclosureButton) {
          this.disclosureButton.forEach((disclosureButton) => {
            disclosureButton.setAttribute('aria-expanded', false);
          });
        }
      }
    }

    customElements.define('sticky-header', StickyHeader);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        //this.showActiveMedia();
        this.constProductPageSwiperCall();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
      constProductPageSwiperCall(showActiveMedia) {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        let activeMediaIndex = 0;

        this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
          if (element == activeMedia) {
            activeMediaIndex = index;
          }
        });
        const prodPageSwiper = new Swiper('#product-page-swiper', {
          zoom: false,
          centeredSlides: false,
          slidesPerView: 1,
          autoheight: true,
          watchSlidesVisibility: false,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          init: false,
          navigation: {
            nextEl: '.swiper-button-next-prod-page',
            prevEl: '.swiper-button-prev-prod-page',
          },

          //on: {
          //	click: function (e) {
          //			if (this.zoom.scale === 1) {
          //			this.zoom.in();
          //			} else {
          //				this.zoom.out();
          //			}
          //	 },
          //},
        });

        prodPageSwiper.on('init', function () {
          prodPageSwiper.slideTo(activeMediaIndex, 0, false);
        });
        prodPageSwiper.init();

        document.querySelector('.product-media-modal__toggle').addEventListener('click', function () {
          if (prodPageSwiper && !prodPageSwiper.destroyed) {
            prodPageSwiper.destroy();
          }
          //prodPageSwiper.destroy()
        });
      }
    }

    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations--single');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }
    }

    customElements.define('product-modal', ProductModal);
    customElements.define('product-recommendations--single', ProductRecommendations);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (typeof window.monochromeInitProductCardSwipers === 'function') {
              try {
                window.monochromeInitProductCardSwipers(this);
              } catch (sliderErr) {}
            }
            const initAnimated = () => {
              const blocks = document.querySelectorAll('.animated-block:not(.visible)');

              const observer = new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                      const block = entry.target;
                      block.classList.add('visible');
                      observer.unobserve(block);
                    }
                  });
                },
                { threshold: 0.1 }
              );

              blocks.forEach((block) => {
                observer.observe(block);
              });
            };
            initAnimated();
            const buttonHoverEffects = () => {
              if (window.innerWidth < 1200) return;
              function wrapLetters(element) {
                const text = element.textContent.trim();
                element.innerHTML = '';

                const wrapperSpan = document.createElement('span');
                wrapperSpan.className = 'wrapper';

                Array.from(text).forEach((char, charIndex) => {
                  const charSpan = document.createElement('span');
                  charSpan.className = 'char';
                  charSpan.textContent = char;
                  charSpan.style.setProperty('--char-index', charIndex + 1);
                  wrapperSpan.appendChild(charSpan);
                });

                element.appendChild(wrapperSpan);
              }

              document.querySelectorAll("[hoverstagger='text']").forEach(wrapLetters);
            };

            buttonHoverEffects();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-actives"] && !Shopify.designMode) return;
  try {
    
  class SknActives extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.rm = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.ease = 'cubic-bezier(.22, 1, .36, 1)';
      this.initReveal();
      this.initLines();
      this.initAccordions();
      this.initJumps();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    initLines() {
      const stage = this.querySelector('[data-stage]');
      if (!stage || !stage.classList.contains('skn-act__stage--lines')) return;
      this.stage = stage;
      this.shape = (stage.dataset.shape || '')
        .split('|')
        .map((r) => r.trim().split(/[\s,]+/).map(Number))
        .filter((r) => r.length === 4 && r.every((n) => Number.isFinite(n)));
      if (!this.shape.length) this.shape = [[0.36, 0.64, 0.25, 0.8]];
      this.desk = window.matchMedia('(min-width: 990px)');
      this.onResize = () => this.queueLines();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.onResize);
        this.ro.observe(stage);
        stage.querySelectorAll('.skn-act__item').forEach((item) => this.ro.observe(item));
      }
      window.addEventListener('resize', this.onResize, { passive: true });
      const img = stage.querySelector('.skn-act__product-img');
      if (img && !img.complete) img.addEventListener('load', this.onResize, { once: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.onResize);
      this.layoutLines();
    }

    queueLines() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this.layoutLines();
      });
    }

    /* Layout-Maße (offset*) statt getBoundingClientRect: unabhängig von Einblend-Transforms */
    layoutLines() {
      const stage = this.stage;
      const prod = stage && stage.querySelector('.skn-act__product');
      if (!prod) return;
      if (!this.desk.matches) {
        stage.classList.remove('is-lined');
        return;
      }
      const sw = stage.clientWidth;
      const sh = stage.clientHeight;
      const pw = prod.offsetWidth;
      const ph = prod.offsetHeight;
      if (!pw || !ph) return;
      /* Tatsächliche Bildfläche bei object-fit: contain */
      const img = prod.querySelector('.skn-act__product-img');
      let iw = pw;
      let ih = ph;
      if (img && img.naturalWidth && img.naturalHeight) {
        const ratio = img.naturalWidth / img.naturalHeight;
        if (ratio > pw / ph) ih = pw / ratio;
        else iw = ph * ratio;
      }
      const ix = (sw - pw) / 2 + (pw - iw) / 2;
      const iy = (sh - ph) / 2 + (ph - ih) / 2;
      const gap = 12;

      stage.querySelectorAll('.skn-act__item').forEach((item) => {
        const line = item.querySelector('.skn-act__line');
        const thumb = item.querySelector('.skn-act__thumb');
        const copy = item.querySelector('.skn-act__copy');
        if (!line || !thumb || !copy) return;
        const right = line.classList.contains('skn-act__line--r');
        const ox = item.offsetLeft;
        const oy = item.offsetTop;
        const ay = oy + thumb.offsetTop + thumb.offsetHeight / 2;
        const ax = right ? ox + thumb.offsetLeft - gap : ox + copy.offsetLeft + copy.offsetWidth + gap;
        let best = null;
        this.shape.forEach(([x1, x2, y1, y2]) => {
          const tx = ix + (right ? x2 : x1) * iw;
          const ty = Math.min(Math.max(ay, iy + y1 * ih), iy + y2 * ih);
          const dx = tx - ax;
          if ((right ? -dx : dx) < 16) return;
          const len = Math.hypot(dx, ty - ay);
          if (!best || len < best.len) best = { dx, dy: ty - ay, len };
        });
        if (!best) {
          line.hidden = true;
          return;
        }
        line.hidden = false;
        line.style.setProperty('--lx', (ax - ox).toFixed(1) + 'px');
        line.style.setProperty('--ly', (ay - oy).toFixed(1) + 'px');
        line.style.setProperty('--len', best.len.toFixed(1) + 'px');
        line.style.setProperty('--ang', Math.atan2(best.dy, best.dx).toFixed(4) + 'rad');
      });
      stage.classList.add('is-lined');
    }

    get motion() {
      return !this.rm.matches && typeof Element.prototype.animate === 'function';
    }

    initReveal() {
      const stage = this.querySelector('[data-stage]');
      const design = window.Shopify && window.Shopify.designMode;
      if (!stage || design || this.rm.matches || !('IntersectionObserver' in window)) return;
      const rect = stage.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) return;
      this.classList.add('is-armed');
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.classList.add('is-in');
          this.io.disconnect();
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
      this.io.observe(stage);
    }

    initAccordions() {
      this.querySelectorAll('.skn-act__acc').forEach((det) => {
        const summary = det.querySelector('summary');
        const body = det.querySelector('[data-body]');
        if (!summary || !body) return;
        summary.addEventListener('click', (e) => {
          if (!this.motion) return;
          e.preventDefault();
          if (det.anim) det.anim.cancel();
          const opening = !det.open || det.classList.contains('is-closing');
          body.style.overflow = 'hidden';
          if (opening) {
            const from = det.open ? body.getBoundingClientRect().height : 0;
            det.classList.remove('is-closing');
            det.open = true;
            const to = body.scrollHeight;
            det.anim = body.animate(
              [{ height: from + 'px', opacity: from ? 1 : 0 }, { height: to + 'px', opacity: 1 }],
              { duration: 300, easing: this.ease }
            );
            det.anim.onfinish = () => { body.style.overflow = ''; det.anim = null; };
          } else {
            const from = body.getBoundingClientRect().height;
            det.classList.add('is-closing');
            det.anim = body.animate(
              [{ height: from + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
              { duration: 250, easing: this.ease }
            );
            det.anim.onfinish = () => {
              det.open = false;
              det.classList.remove('is-closing');
              body.style.overflow = '';
              det.anim = null;
            };
          }
        });
      });
    }

    initJumps() {
      this.querySelectorAll('[data-tab-jump]').forEach((btn) => {
        const target = this.findTab(btn.dataset.tabJump);
        if (!target) return;
        btn.hidden = false;
        btn.addEventListener('click', () => {
          const hit = this.findTab(btn.dataset.tabJump);
          if (!hit) return;
          if (hit.pacc) {
            /* Akkordeon in der Kaufbox (sections/skn-main) */
            const item = hit.pacc.closest('[data-pacc]');
            if (item && !item.classList.contains('is-open')) hit.pacc.click();
            item.scrollIntoView({ behavior: this.rm.matches ? 'auto' : 'smooth', block: 'start' });
            hit.pacc.focus({ preventScroll: true });
            return;
          }
          const { host, index } = hit;
          const tab = host.querySelectorAll('[data-tab]')[index];
          const acc = host.querySelectorAll('[data-acc]')[index];
          const list = host.querySelector('[role="tablist"]');
          const tabsVisible = list && window.getComputedStyle(list).display !== 'none';
          if (tabsVisible && tab) {
            tab.click();
          } else if (acc && acc.getAttribute('aria-expanded') !== 'true') {
            acc.click();
          }
          host.scrollIntoView({ behavior: this.rm.matches ? 'auto' : 'smooth', block: 'start' });
          const focusEl = tabsVisible ? tab : acc;
          if (focusEl) focusEl.focus({ preventScroll: true });
        });
      });
    }

    findTab(name) {
      const wanted = (name || '').trim().toLowerCase();
      if (!wanted) return null;
      const hosts = document.querySelectorAll('skn-tabs');
      for (const host of hosts) {
        const tabs = [...host.querySelectorAll('[data-tab]')];
        const index = tabs.findIndex((t) => t.textContent.trim().toLowerCase().includes(wanted));
        if (index > -1) return { host, index };
      }
      const pacc = [...document.querySelectorAll('[data-pacc-btn]')].find((b) => b.textContent.trim().toLowerCase().includes(wanted));
      if (pacc) return { pacc };
      return null;
    }
  }
  if (!customElements.get('skn-actives')) customElements.define('skn-actives', SknActives);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-announcement"] && !Shopify.designMode) return;
  try {
    
  class SknAnnounce extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.track) return;
      /* Nichts in der Leiste darf als Bild/Link gezogen werden */
      this.track.addEventListener('dragstart', (e) => e.preventDefault());
      if (this.slides.length < 2) return;
      this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
      this.ms = (Number(this.dataset.interval) || 4) * 1000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.start);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.start);

      /* Wischen links/rechts, vertikales Scrollen der Seite bleibt frei (touch-action: pan-y) */
      this.track.addEventListener('pointerdown', (e) => { this.sx = e.clientX; this.sy = e.clientY; this.swiped = false; }, { passive: true });
      this.track.addEventListener('pointerup', (e) => {
        if (this.sx == null) return;
        const dx = e.clientX - this.sx, dy = e.clientY - this.sy;
        this.sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { this.swiped = true; this.go(this.index + (dx < 0 ? 1 : -1), dx > 0); this.start(); }
      }, { passive: true });
      this.track.addEventListener('pointercancel', () => { this.sx = null; }, { passive: true });
      /* Nach einem Wisch keinen Link öffnen */
      this.track.addEventListener('click', (e) => { if (this.swiped) { e.preventDefault(); this.swiped = false; } }, true);

      document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.start()));
      this.start();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    start = () => {
      if (this.reduced) return;
      clearInterval(this.timer);
      this.timer = setInterval(() => this.go(this.index + 1, false), this.ms);
    };

    pause = () => clearInterval(this.timer);

    go(to, back) {
      const n = this.slides.length;
      const i = ((to % n) + n) % n;
      if (i === this.index) return;
      const prev = this.slides[this.index];
      const next = this.slides[i];

      next.classList.remove('is-leaving');
      next.classList.add('no-anim');
      next.classList.toggle('is-back', !!back);
      void next.offsetWidth;
      next.classList.remove('no-anim');

      prev.classList.toggle('is-back', !!back);
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      prev.setAttribute('aria-hidden', 'true');
      prev.inert = true;
      clearTimeout(prev._t);
      prev._t = setTimeout(() => {
        prev.classList.add('no-anim');
        prev.classList.remove('is-leaving', 'is-back');
        void prev.offsetWidth;
        prev.classList.remove('no-anim');
      }, 650);

      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
      next.inert = false;
      this.index = i;
    }
  }
  if (!customElements.get('skn-announce')) customElements.define('skn-announce', SknAnnounce);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-cart-page"]) return;
  try {
    
  /* Warenkorbseite: Entfernen klappt die Zeile erst weich zu, dann folgt der Standard-Link */
  (function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-skn-cp] [data-cp-remove]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var row = link.closest('.skn-cp__item');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!row || reduce || typeof row.animate !== 'function') return;
      e.preventDefault();
      if (row.classList.contains('is-leaving')) return;
      row.classList.add('is-leaving');
      var cs = getComputedStyle(row);
      var h = row.getBoundingClientRect().height + 'px';
      row.style.overflow = 'hidden';
      row.style.animation = 'none';
      var anim = row.animate([
        { height: h, paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, borderTopWidth: cs.borderTopWidth, borderBottomWidth: cs.borderBottomWidth, opacity: 1, transform: 'none', offset: 0 },
        { height: h, paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, borderTopWidth: cs.borderTopWidth, borderBottomWidth: cs.borderBottomWidth, opacity: 0, transform: 'translate3d(14px, 0, 0)', offset: .42 },
        { height: '0px', paddingTop: '0px', paddingBottom: '0px', borderTopWidth: '0px', borderBottomWidth: '0px', opacity: 0, transform: 'translate3d(14px, 0, 0)', offset: 1 }
      ], { duration: 360, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'forwards' });
      var went = false;
      var go = function () { if (went) return; went = true; window.location.href = link.href; };
      anim.onfinish = go;
      setTimeout(go, 700);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-main"] && !Shopify.designMode) return;
  try {
    
  class SknGallery extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.zoomBtn = this.querySelector('[data-zoom]');
      if (!this.stage) return;
      this.index = 0;

      /* Vollansicht: nutzt die vorhandene Lightbox (sections/skn-extras), die auf Klicks auf .skn-gal__img hört */
      this.zoomBtn?.addEventListener('click', () => this.openLightbox(this.zoomBtn));
      this.stage.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.openLightbox(this.stage); }
        else if (this.slides.length > 1 && e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
        else if (this.slides.length > 1 && e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
      });
      this.stage.addEventListener('click', (e) => { if (e.target.closest('.skn-gal__img')) this.returnFocus = this.zoomBtn || this.stage; });

      /* Desktop: Galerie bleibt immer stehen, während die Kaufbox scrollt (bis zum Ende des Produktbereichs).
         Ist die Galerie höher als das Fenster unter dem Header, klebt sie mit ihrer Unterkante, damit Thumbnails erreichbar bleiben. */
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.fit = () => {
        if (!this.desktop.matches) { this.style.top = ''; this.style.position = ''; return; }
        const hdr = document.querySelector('[id$="__skn_header"]');
        const hdrH = hdr && getComputedStyle(hdr).position === 'sticky' ? hdr.getBoundingClientRect().height : 0;
        const galH = this.getBoundingClientRect().height;
        const top = Math.round(Math.min(hdrH + 16, window.innerHeight - galH - 16));
        this.style.position = '';
        this.style.top = top + 'px';
      };
      this.fit();
      window.addEventListener('resize', this.fit, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(this.fit).observe(this);

      if (this.slides.length < 2) return;
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(Number(t.dataset.thumb))));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));
      this.querySelector('[data-next-o]')?.addEventListener('click', () => this.step(1));
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
      this.stage.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      if (this.fit) window.removeEventListener('resize', this.fit);
    }

    onScroll = () => {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => {
        const i = Math.round(this.stage.scrollLeft / this.stage.clientWidth);
        this.mark(i);
      });
    };

    step(d) {
      const n = this.slides.length;
      this.go((this.index + d + n) % n);
    }

    go(i) {
      this.stage.scrollTo({ left: this.slides[i].offsetLeft - this.stage.offsetLeft, behavior: 'smooth' });
      this.mark(i);
    }

    mark(i) {
      if (i === this.index && this.thumbs[i]?.getAttribute('aria-current') === 'true') return;
      this.index = i;
      this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      const strip = this.thumbs[i]?.closest('[data-thumbs]');
      const li = this.thumbs[i]?.parentElement;
      if (strip && li) {
        const l = li.offsetLeft - strip.offsetLeft, r = l + li.offsetWidth;
        if (l < strip.scrollLeft) strip.scrollTo({ left: l, behavior: 'smooth' });
        else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth, behavior: 'smooth' });
      }
    }

    openLightbox(from) {
      const img = this.slides[this.index]?.querySelector('.skn-gal__img');
      if (!img || typeof img.click !== 'function') return;
      this.returnFocus = from;
      img.click();
    }
  }

  /* Tastatur in der Vollansicht: Fokus hinein, Tab bleibt im Dialog, beim Schließen zurück zum Auslöser */
  const sknLbTrap = () => {
    const lb = document.querySelector('[data-skn-lightbox]');
    if (!lb || lb.dataset.sknTrap) return;
    lb.dataset.sknTrap = '1';
    let opener = null;
    const focusables = () => [...lb.querySelectorAll('button:not([hidden])')].filter((b) => b.offsetParent !== null);
    new MutationObserver(() => {
      if (!lb.hidden) {
        const gal = [...document.querySelectorAll('skn-gallery')].find((g) => g.returnFocus) || document.querySelector('skn-gallery');
        opener = gal?.returnFocus || document.activeElement;
        if (gal) gal.returnFocus = null;
        requestAnimationFrame(() => lb.querySelector('[data-lb-close]')?.focus({ preventScroll: true }));
      } else if (opener) {
        opener.focus?.({ preventScroll: true });
        opener = null;
      }
    }).observe(lb, { attributes: true, attributeFilter: ['hidden'] });
    document.addEventListener('keydown', (e) => {
      if (lb.hidden || e.key !== 'Tab') return;
      const f = focusables();
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (!lb.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sknLbTrap); else sknLbTrap();
  if (!customElements.get('skn-gallery')) customElements.define('skn-gallery', SknGallery);

  /* Kaufbox: Variantenwahl, Angebots-Karten (einzeln oder als Set) und feste Kaufleiste.
     Das Formular wird normal an /cart/add geschickt (kein eigenes fetch), damit iCart und Shopify Subscriptions
     den Vorgang wie gewohnt abfangen. Eine Angebots-Karte setzt nur das versteckte Feld "id" auf ihre Variante. */
  class SknBuybox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]') || this.querySelector('form');
      this.variants = [...this.querySelectorAll('[data-variant-input]')];
      this.offers = [...this.querySelectorAll('[data-offer]')];
      this.own = this.offers.find((o) => 'own' in o.dataset) || null;
      this.atc = this.querySelector('[data-atc]');
      this.atcLabel = this.querySelector('[data-atc-label]');
      this.atcPrice = this.querySelector('.skn-atc [data-atc-price]');
      this.prices = [...this.querySelectorAll('[data-atc-price]')];
      this.mainPrice = this.querySelector('[data-main-price]');
      this.compare = this.querySelector('[data-compare]');
      this.unit = this.querySelector('[data-unit]');
      this.idInput = this.querySelector('[data-id-input]');
      this.live = this.querySelector('[data-deal-live]');
      this.formApps = [...this.querySelectorAll('[data-form-app]')];
      this.sticky = this.querySelector('[data-sticky]');
      this.stickyBtn = this.querySelector('[data-sticky-btn]');
      this.stickyTitle = this.querySelector('[data-sticky-title]');
      this.ownName = this.stickyTitle ? this.stickyTitle.textContent : '';
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.variants.forEach((v) => v.addEventListener('change', () => this.onVariant(v)));
      this.offers.forEach((o) => o.addEventListener('change', () => this.apply(o, true)));
      this.querySelectorAll('[data-deal-chip]').forEach((chip) => chip.addEventListener('click', () => this.onChip(chip)));
      this.stickyBtn?.addEventListener('click', this.onSticky);

      /* Browser können die Radio-Auswahl nach "Zurück" wiederherstellen: Zustand daher einmal abgleichen */
      const start = this.offers.find((o) => o.checked);
      if (start && start !== this.own) this.apply(start, false);

      /* Feste Kaufleiste: sofort sichtbar (Anzeigen-Traffic soll nicht erst scrollen müssen),
         nur ausgeblendet, solange der Haupt-Button ".skn-atc" im Formular selbst im Sichtbereich ist. */
      if (this.sticky && this.atc) {
        const setStickyVisible = (mainVisible) => { this.sticky.hidden = !!mainVisible; };
        const rect = this.atc.getBoundingClientRect();
        setStickyVisible(rect.top < window.innerHeight && rect.bottom > 0);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => setStickyVisible(entry.isIntersecting));
          this.observer.observe(this.atc);
        }
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    /* Schnittstelle für sections/skn-cart-drawer: der Warenkorb fängt das Absenden ab, liest die gewählte Variante
       über "active" und schaltet den Button danach über "sync" wieder frei. Ohne diese beiden wurde nichts hinzugefügt. */
    get active() {
      const id = this.idInput?.value;
      return id ? { dataset: { variant: id, qty: '1' } } : null;
    }

    sync() {
      if (!this.atc) return;
      const src = this.offers.find((o) => o.checked) || this.variants.find((v) => v.checked);
      this.atc.disabled = src ? src.dataset.available !== 'true' : false;
    }

    /* Variante des Produkts selbst gewählt: Kopfpreis, URL und die Karte "Einzeln" nachziehen */
    onVariant(v) {
      const d = v.dataset;
      if (this.mainPrice) this.mainPrice.textContent = d.price;
      if (this.compare) this.compare.textContent = d.compare || '';
      if (this.unit) this.unit.textContent = d.unit || '';
      if (window.history && window.URL) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', d.variant);
        window.history.replaceState({}, '', url.toString());
      }
      if (this.own) {
        Object.assign(this.own.dataset, { variant: d.variant, price: d.price, compare: d.compare || '', unit: d.unit || '', available: d.available });
        this.own.value = d.variant;
        const card = this.own.closest('[data-deal]');
        const set = (sel, txt) => { const el = card?.querySelector(sel); if (el) el.textContent = txt; };
        set('[data-deal-price]', d.price);
        set('[data-deal-compare]', d.compare || '');
        set('[data-deal-unit]', d.unit || '');
        if (!this.own.checked) return;
      }
      this.apply(this.own || v, true);
    }

    /* Routine-Karte mit Chips (Mizellenwasser): Chip setzt die Daten der Karte auf das gewählte Set und wählt sie aus */
    onChip(chip) {
      const card = chip.closest('[data-deal]');
      const input = card?.querySelector('[data-offer]');
      if (!input) return;
      const c = chip.dataset;
      card.querySelectorAll('[data-deal-chip]').forEach((x) => x.setAttribute('aria-pressed', x === chip ? 'true' : 'false'));
      Object.assign(input.dataset, { variant: c.variant, price: c.price, compare: c.compare || '', unit: c.unit || '', available: c.available, name: c.name, url: c.url, tpl: c.tpl || '' });
      input.value = c.variant;
      input.disabled = c.available !== 'true';
      const set = (sel, txt) => { const el = card.querySelector(sel); if (el) el.textContent = txt; };
      set('[data-deal-price]', c.price);
      set('[data-deal-compare]', c.compare || '');
      set('[data-deal-unit]', c.unit || '');
      const save = card.querySelector('[data-deal-save]');
      if (save) { save.textContent = c.save || ''; save.hidden = !c.save; }
      const pct = card.querySelector('[data-deal-pct]');
      if (pct) pct.innerHTML = c.pct || '';
      input.dataset.save = c.save || '';
      this.pop(card.querySelector('.skn-deal__prices'));
      card.querySelectorAll('[data-chip-img]').forEach((img) => { img.hidden = img.dataset.chipImg !== c.img; });
      const info = card.querySelector('[data-set-info-open]');
      if (info && c.dialog) { info.dataset.setInfoOpen = c.dialog; info.setAttribute('aria-controls', c.dialog); }
      const infoName = card.querySelector('[data-deal-info-name]');
      if (infoName) infoName.textContent = ' ' + (c.name || '');
      if (input.disabled) return;
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        this.apply(input, true);
        if (this.sknSwap && this.sknSwap.select) { this.sknSwap.current = null; this.sknSwap.select(input, true); }
      }
    }

    apply(src, fromUser) {
      if (!src || !this.atc) return;
      const d = src.dataset;
      const isSet = this.offers.length > 0 && src !== this.own && !this.variants.includes(src);

      this.offers.forEach((o) => o.closest('[data-deal]')?.classList.toggle('is-checked', o === src));

      if (this.idInput && this.idInput.value !== d.variant) {
        this.idInput.value = d.variant;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* Abo-Optionen gehören zum Einzelprodukt: bei Sets ausblenden und nicht mitsenden */
      this.formApps.forEach((app) => {
        app.toggleAttribute('data-offer-off', isSet);
        app.querySelectorAll('[name="selling_plan"], [name="purchase_option"]').forEach((f) => { f.disabled = isSet; });
      });

      this.prices.forEach((p) => { if (p !== this.atcPrice) p.textContent = d.price; });
      /* Kopfpreis unter dem Titel folgt der gewählten Karte (Titel und Galerie zeigen dann das Set) */
      if (this.offers.length && this.offers.includes(src)) {
        if (this.mainPrice) this.mainPrice.textContent = d.price;
        if (this.compare) this.compare.textContent = d.compare || '';
        if (this.unit) this.unit.textContent = d.unit || '';
      }
      this.swapPrice(d.price, fromUser);

      /* Ersparnis sichtbar machen: Preis-Spalte der gewählten Karte kurz einblenden, Hinweis am Kaufbutton */
      if (fromUser) this.pop(src.closest('[data-deal]')?.querySelector('.skn-deal__prices'));
      const atcSave = this.atc.querySelector('[data-atc-save]');
      if (atcSave) {
        const txt = isSet && d.available === 'true' ? (d.save || '') : '';
        if (txt !== atcSave.textContent || atcSave.hidden !== !txt) {
          atcSave.textContent = txt;
          atcSave.hidden = !txt;
          if (txt && fromUser) this.pop(atcSave);
        }
      }

      const available = d.available === 'true';
      const label = available ? this.atc.dataset.label : 'Ausverkauft';
      this.atcLabel.textContent = label;
      this.atc.disabled = !available;
      if (this.stickyBtn) {
        this.stickyBtn.textContent = label;
        this.stickyBtn.disabled = !available;
      }
      if (this.stickyTitle) this.stickyTitle.textContent = isSet ? d.name : this.ownName;

      if (fromUser && this.live) {
        this.live.textContent = (d.name || '') + ' ausgewählt, ' + d.price + (available ? '' : ', ausverkauft');
      }
    }

    /* Kurzes Einblenden (Ersparnis, Hinweis am Button). Bei „Bewegung reduzieren“ ohne Animation */
    pop(el) {
      if (!el || this.reduced || !el.animate) return;
      el.animate([{ opacity: 0.2, transform: 'translateY(3px) scale(.96)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'cubic-bezier(.23, 1, .32, 1)' });
    }

    /* Preis im Button weich überblenden: kurz ausblenden, Text tauschen, von unten einblenden */
    swapPrice(text, animate) {
      const el = this.atcPrice;
      if (!el || el.textContent === text) return;
      if (!animate || this.reduced || !el.animate) { el.textContent = text; return; }
      this.priceAnim?.cancel();
      this.priceAnim = el.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-4px)' }], { duration: 110, easing: 'ease-in' });
      this.priceAnim.onfinish = () => {
        el.textContent = text;
        this.priceAnim = el.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }], { duration: 200, easing: 'cubic-bezier(.23, 1, .32, 1)' });
      };
      this.priceAnim.oncancel = () => { el.textContent = text; };
    }

    onSticky = () => {
      if (!this.atc || this.atc.disabled) {
        this.form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (this.form?.requestSubmit) this.form.requestSubmit(this.atc);
      else this.atc.click();
    };
  }
  if (!customElements.get('skn-buybox')) customElements.define('skn-buybox', SknBuybox);

  /* Set-Übersicht "Was ist drin?": natives <dialog> (Top-Layer, Hintergrund inert), weiche Ein-/Ausblendung,
     Fokus-Falle, ESC schließt, Scroll-Sperre. "Dieses Set wählen" setzt die Angebots-Karte wie ein Klick darauf. */
  if (!window.SknSetInfo) {
    window.SknSetInfo = true;
    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let active = null;
    let opener = null;
    let timer = 0;
    const focusables = (root) => [...root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((el) => el.getClientRects().length > 0);
    const lock = (on) => document.documentElement.classList.toggle('skn-si-lock', on);

    const finish = (dlg) => {
      clearTimeout(timer);
      dlg.classList.remove('is-open');
      if (dlg.open) dlg.close();
      lock(false);
      if (active === dlg) active = null;
      const back = opener;
      opener = null;
      if (back && document.contains(back)) back.focus({ preventScroll: true });
    };

    const close = (dlg) => {
      if (!dlg || !dlg.open) return;
      dlg.classList.remove('is-open');
      dlg.classList.add('is-closing');
      clearTimeout(timer);
      if (reduced()) { timer = setTimeout(() => finish(dlg), 120); return; }
      timer = setTimeout(() => finish(dlg), 220);
    };

    const open = (dlg, trigger, item) => {
      if (!dlg || typeof dlg.showModal !== 'function') return;
      clearTimeout(timer);
      if (active && active !== dlg && active.open) { active.classList.remove('is-open'); active.close(); }
      opener = trigger || null;
      active = dlg;
      dlg.classList.remove('is-closing');
      dlg.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      if (!dlg.open) dlg.showModal();
      lock(true);
      const body = dlg.querySelector('.skn-si__body');
      const items = [...dlg.querySelectorAll('[data-set-info-item]')];
      items.forEach((el) => el.classList.remove('is-focus'));
      if (body) body.scrollTop = 0;
      const target = item != null && item !== '' ? dlg.querySelector('[data-set-info-item="' + Number(item) + '"]') : null;
      if (target && body) {
        target.classList.add('is-focus');
        body.scrollTop = Math.max(0, target.getBoundingClientRect().top - body.getBoundingClientRect().top - 16);
      }
      dlg.querySelector('.skn-si__title')?.focus({ preventScroll: true });
      requestAnimationFrame(() => requestAnimationFrame(() => dlg.classList.add('is-open')));
    };

    /* Bilder im geschlossenen Fenster laden erst bei Bedarf: schon beim Zeigen auf den Button vorladen */
    const preload = (event) => {
      const trigger = event.target.closest?.('[data-set-info-open]');
      const dlg = trigger && document.getElementById(trigger.dataset.setInfoOpen);
      dlg?.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    };
    document.addEventListener('pointerover', preload, { passive: true });
    document.addEventListener('focusin', preload);
    document.addEventListener('touchstart', preload, { passive: true });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-set-info-open]');
      if (trigger) {
        event.preventDefault();
        open(document.getElementById(trigger.dataset.setInfoOpen), trigger, trigger.dataset.setInfoItem);
        return;
      }
      const dlg = event.target.closest('[data-set-info]');
      if (!dlg) return;
      const select = event.target.closest('[data-set-info-select]');
      if (select) {
        const input = document.getElementById(select.dataset.setInfoSelect);
        if (input && !input.disabled) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const card = input.closest('[data-deal]');
          opener = card?.querySelector('[data-set-info-open]') || opener;
        }
        close(dlg);
        return;
      }
      if (event.target.closest('[data-set-info-close]')) close(dlg);
    });

    /* ESC: animiert schließen statt hart */
    document.addEventListener('cancel', (event) => {
      if (event.target.matches?.('[data-set-info]')) {
        event.preventDefault();
        close(event.target);
      }
    }, true);

    /* Falls der Browser das Fenster anderweitig schließt: Sperre sicher lösen */
    document.addEventListener('close', (event) => {
      if (event.target.matches?.('[data-set-info]') && !document.querySelector('[data-set-info][open]')) {
        lock(false);
        if (active === event.target) active = null;
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (!active || !active.open) return;
      if (event.key === 'Escape') { event.preventDefault(); close(active); return; }
      if (event.key !== 'Tab') return;
      const list = focusables(active.querySelector('.skn-si__panel') || active);
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      const current = document.activeElement;
      if (event.shiftKey && (current === first || !list.includes(current))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && current === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* FAQ: weich auf- und zuklappen, immer nur eine Frage offen, damit die Seite nicht springt */
  if (!window.SknFaq) {
    window.SknFaq = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const animate = (item, open) => {
      item.dataset.target = open ? 'open' : 'closed';
      const body = item.querySelector('.skn-faq__body');
      if (!body || reduce || !body.animate) { item.open = open; return; }
      if (item._anim) item._anim.cancel();
      const start = open ? 0 : body.offsetHeight;
      if (open) item.open = true;
      const end = open ? body.scrollHeight : 0;
      item.classList.add('is-animating');
      item._anim = body.animate(
        [{ height: start + 'px', opacity: open ? 0 : 1 }, { height: end + 'px', opacity: open ? 1 : 0 }],
        { duration: open ? 320 : 240, easing: 'cubic-bezier(.16, 1, .3, 1)' }
      );
      item._anim.onfinish = () => {
        if (!open) item.open = false;
        item._anim = null;
        item.classList.remove('is-animating');
      };
      item._anim.oncancel = () => { item._anim = null; };
    };
    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.skn-faq__q');
      if (!summary) return;
      const item = summary.parentElement;
      event.preventDefault();
      const opening = (item.dataset.target || (item.open ? 'open' : 'closed')) !== 'open';
      const group = item.closest('.skn-faq');
      if (opening && group) {
        group.querySelectorAll('.skn-faq__item[open]').forEach((other) => { if (other !== item) animate(other, false); });
      }
      animate(item, opening);
    });
  }

  /* Akkordeons in der Kaufbox (.skn-pacc): Punkte klappen unabhängig voneinander auf, Höhe animiert per CSS
     (grid-template-rows). Damit ein Punkt immer nach unten wächst und die Überschrift an ihrem Platz bleibt:
     kein automatisches Schließen anderer Punkte (das würde den Inhalt darüber verkürzen) und Scroll-Anchoring
     des Browsers während der Animation aus (sonst hält Chrome ein Element unterhalb fest und schiebt die Seite).
     Delegiert, weil assets/skn-offer-swap.js den Block beim Set-Wechsel austauscht. */
  if (!window.SknPacc) {
    window.SknPacc = {
      set(item, open) {
        const btn = item.querySelector('[data-pacc-btn]');
        item.classList.toggle('is-open', open);
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      },
      open(item) { this.set(item, true); }
    };
    let anchorTimer = 0;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-pacc-btn]');
      if (!btn) return;
      const item = btn.closest('[data-pacc]');
      if (!item) return;
      const root = document.documentElement;
      const top = btn.getBoundingClientRect().top;
      root.style.overflowAnchor = 'none';
      window.SknPacc.set(item, !item.classList.contains('is-open'));
      /* Falls trotzdem etwas verrutscht (z. B. Schrift lädt nach), Überschrift zurück an ihren Platz */
      const drift = btn.getBoundingClientRect().top - top;
      if (Math.abs(drift) > 1) window.scrollBy(0, drift);
      window.clearTimeout(anchorTimer);
      anchorTimer = window.setTimeout(() => { root.style.overflowAnchor = ''; }, 450);
    });
  }

  /* "Mehr lesen" in der Beschreibung: eigener, kleiner Umschalter (Höhe animiert wie die Akkordeon-Punkte oben,
     kein hartes Aufklappen). Delegiert aus demselben Grund wie SknPacc (Set-Wechsel tauscht den Block aus). */
  if (!window.SknMore) {
    window.SknMore = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-pmore-btn]');
      if (!btn) return;
      const wrap = btn.closest('[data-pmore]');
      if (!wrap) return;
      const open = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Weniger anzeigen' : 'Mehr lesen';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-results"] && !Shopify.designMode) return;
  try {
    
  class SknResults extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelectorAll('[data-cmp]').forEach((cmp) => this.bind(cmp));
      if (this.hasAttribute('data-reveal')) this.initReveal();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    initReveal() {
      const design = window.Shopify && window.Shopify.designMode;
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (design || reduce || !('IntersectionObserver' in window)) return;
      const rect = this.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) return;
      this.classList.add('is-armed');
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.classList.add('is-in');
          this.io.disconnect();
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
      this.io.observe(this);
    }

    bind(cmp) {
      const range = cmp.querySelector('[data-range]');
      if (!range) return;
      let last = 50;
      let dragging = false;
      const labelBefore = cmp.getAttribute('data-label-before') || 'links';
      const labelAfter = cmp.getAttribute('data-label-after') || 'rechts';
      const set = (value) => {
        const v = Math.max(0, Math.min(100, Math.round(value)));
        last = v;
        range.value = String(v);
        cmp.style.setProperty('--pos', v + '%');
        let text = 'Trennlinie in der Mitte';
        if (v < 50) text = 'Trennlinie bei ' + v + ' Prozent, mehr ' + labelAfter + ' sichtbar';
        if (v > 50) text = 'Trennlinie bei ' + v + ' Prozent, mehr ' + labelBefore + ' sichtbar';
        range.setAttribute('aria-valuetext', text);
      };
      const fromEvent = (e) => {
        const rect = cmp.getBoundingClientRect();
        if (!rect.width) return;
        set(((e.clientX - rect.left) / rect.width) * 100);
      };

      range.addEventListener('input', () => {
        if (dragging) { range.value = String(last); return; }
        set(Number(range.value));
      });

      let active = null;
      let startX = 0;
      let startY = 0;

      range.addEventListener('pointerdown', (e) => {
        if (e.button !== undefined && e.button !== 0) return;
        active = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        dragging = e.pointerType === 'mouse';
        if (dragging) {
          e.preventDefault();
          range.focus({ preventScroll: true });
          try { range.setPointerCapture(e.pointerId); } catch (err) {}
          cmp.classList.add('is-dragging');
          fromEvent(e);
        }
      });

      range.addEventListener('pointermove', (e) => {
        if (active !== e.pointerId) return;
        if (!dragging) {
          const dx = Math.abs(e.clientX - startX);
          const dy = Math.abs(e.clientY - startY);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { active = null; return; }
          dragging = true;
          try { range.setPointerCapture(e.pointerId); } catch (err) {}
          cmp.classList.add('is-dragging');
        }
        e.preventDefault();
        fromEvent(e);
      });

      const end = (e) => {
        if (active !== e.pointerId) return;
        if (!dragging && e.type === 'pointerup') fromEvent(e);
        active = null;
        dragging = false;
        cmp.classList.remove('is-dragging');
      };
      range.addEventListener('pointerup', end);
      range.addEventListener('pointercancel', (e) => {
        if (active !== e.pointerId) return;
        active = null;
        dragging = false;
        cmp.classList.remove('is-dragging');
      });

      set(Number(range.value) || 50);
    }
  }
  if (!customElements.get('skn-results')) customElements.define('skn-results', SknResults);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-tabs"] && !Shopify.designMode) return;
  try {
    
  class SknTabs extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.accs = [...this.querySelectorAll('[data-acc]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.wrap = this.querySelector('[data-panels]');
      this.list = this.querySelector('[role="tablist"]');
      this.ind = this.querySelector('.skn-tabs__ind');
      if (!this.panels.length) return;
      this.markFacts();
      this.active = 0;
      this.open = new Set([0]);
      this.ease = 'cubic-bezier(.22, 1, .36, 1)';
      this.duration = 320;
      this.mq = window.matchMedia('(min-width: 750px)');
      this.rm = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.selectTab(i));
        tab.addEventListener('keydown', (e) => {
          const last = this.tabs.length - 1;
          let next = null;
          if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
          else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = last;
          if (next === null) return;
          e.preventDefault();
          this.selectTab(next);
          this.tabs[next].focus();
        });
      });
      this.accs.forEach((acc, i) => acc.addEventListener('click', () => this.toggle(i)));

      this.onMode = () => this.applyMode();
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMode);
      else this.mq.addListener(this.onMode);
      this.applyMode();

      if (this.list && this.ind && 'ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.moveIndicator());
        this.ro.observe(this.list);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.moveIndicator());
    }

    /* „Das Wichtigste auf einen Blick" -> Liste als Kachel-Raster markieren */
    markFacts() {
      this.querySelectorAll('.skn-tabs__copy :is(h2, h3, h4, h5, h6, p)').forEach((h) => {
        const txt = (h.textContent || '').trim().toLowerCase();
        if (txt.length > 60 || !/auf einen blick|das wichtigste|kurz und knapp|fakten/.test(txt)) return;
        const list = h.nextElementSibling;
        if (list && list.tagName === 'UL') list.classList.add('skn-tabs__facts');
      });
    }

    /* Gleitende Pille unter dem aktiven Tab */
    moveIndicator(animate) {
      if (!this.list || !this.ind) return;
      const tab = this.tabs[this.active];
      if (!tab || !this.mq.matches || !tab.offsetWidth) {
        this.list.classList.remove('has-ind');
        return;
      }
      const x = tab.offsetLeft;
      const w = tab.offsetWidth;
      const px = this.indX;
      const pw = this.indW;
      this.indX = x;
      this.indW = w;
      this.ind.style.setProperty('--ind-x', x + 'px');
      this.ind.style.setProperty('--ind-w', w + 'px');
      /* Breite springt sofort, die Bewegung läuft nur über transform (translate + scaleX) */
      if (animate && this.motion && this.list.classList.contains('is-ready') && pw && (px !== x || pw !== w)) {
        if (this.indAnim) this.indAnim.cancel();
        this.indAnim = this.ind.animate(
          [{ transform: 'translate3d(' + px + 'px, 0, 0) scaleX(' + (pw / w) + ')' }, { transform: 'translate3d(' + x + 'px, 0, 0) scaleX(1)' }],
          { duration: 340, easing: this.ease }
        );
      }
      if (!this.list.classList.contains('has-ind')) {
        this.list.classList.add('has-ind');
        requestAnimationFrame(() => requestAnimationFrame(() => this.list.classList.add('is-ready')));
      }
      if (this.list.scrollWidth > this.list.clientWidth) {
        const left = tab.offsetLeft - (this.list.clientWidth - tab.offsetWidth) / 2;
        this.list.scrollTo({ left: Math.max(0, left), behavior: this.motion ? 'smooth' : 'auto' });
      }
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (!this.mq || !this.onMode) return;
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMode);
      else this.mq.removeListener(this.onMode);
    }

    get motion() {
      return !this.rm.matches && typeof Element.prototype.animate === 'function';
    }

    applyMode() {
      const tabsMode = this.mq.matches && this.tabs.length === this.panels.length;
      this.panels.forEach((panel) => {
        if (panel.anim) panel.anim.cancel();
        panel.style.overflow = '';
        delete panel.dataset.closing;
      });
      if (tabsMode) {
        if (!this.open.has(this.active)) this.active = this.open.size ? Math.min(...this.open) : 0;
        this.open = new Set([this.active]);
        this.panels.forEach((panel, i) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[i].id);
          panel.tabIndex = 0;
          panel.hidden = i !== this.active;
        });
      } else {
        this.panels.forEach((panel, i) => {
          panel.setAttribute('role', 'region');
          panel.setAttribute('aria-labelledby', this.accs[i].id);
          panel.removeAttribute('tabindex');
          panel.hidden = !this.open.has(i);
        });
      }
      this.syncAria();
      this.moveIndicator();
    }

    syncAria() {
      this.tabs.forEach((tab, i) => {
        const on = i === this.active;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      this.accs.forEach((acc, i) => acc.setAttribute('aria-expanded', this.open.has(i) ? 'true' : 'false'));
    }

    selectTab(index) {
      if (index === this.active && !this.panels[index].hidden) return;
      const prev = this.panels[this.active];
      const next = this.panels[index];
      const from = this.wrap.getBoundingClientRect().height;
      const dir = index > this.active ? 1 : -1;
      this.active = index;
      this.open = new Set([index]);
      this.syncAria();
      this.moveIndicator(true);
      this.panels.forEach((panel) => { if (panel !== next) panel.hidden = true; });
      if (prev && prev !== next) prev.hidden = true;
      next.hidden = false;
      if (!this.motion) return;

      const to = this.wrap.getBoundingClientRect().height;
      if (this.wrapAnim) this.wrapAnim.cancel();
      if (Math.abs(to - from) > 1) {
        const anim = this.wrap.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: this.duration, easing: this.ease });
        this.wrap.style.overflow = 'hidden';
        const done = () => { if (this.wrapAnim === anim) { this.wrap.style.overflow = ''; this.wrapAnim = null; } };
        anim.onfinish = done;
        anim.oncancel = done;
        this.wrapAnim = anim;
      }
      if (next.anim) next.anim.cancel();
      const copy = next.firstElementChild || next;
      next.anim = copy.animate(
        [{ opacity: 0, transform: 'translate3d(' + (dir * 14) + 'px, 4px, 0)' }, { opacity: 1, transform: 'none' }],
        { duration: 340, easing: this.ease }
      );
      this.revealSteps(next);
    }

    /* Anwendung: Schritte erscheinen nacheinander (nur mit Bewegung) */
    revealSteps(panel) {
      if (!this.motion) return;
      panel.querySelectorAll('.skn-tabs__steps li').forEach((li, i) => {
        li.animate(
          [{ opacity: 0, transform: 'translate3d(0, 8px, 0)' }, { opacity: 1, transform: 'none' }],
          { duration: 420, delay: 60 + i * 70, easing: this.ease, fill: 'backwards' }
        );
      });
    }

    toggle(index) {
      const panel = this.panels[index];
      const opening = panel.hidden || panel.dataset.closing === '1';
      const from = panel.hidden ? 0 : panel.getBoundingClientRect().height;
      if (panel.anim) panel.anim.cancel();
      delete panel.dataset.closing;

      if (opening) {
        this.open.add(index);
        this.active = index;
        panel.hidden = false;
      } else {
        this.open.delete(index);
      }
      this.syncAria();

      if (!this.motion) {
        panel.hidden = !opening;
        return;
      }

      panel.style.overflow = 'hidden';
      let anim;
      if (opening) {
        const to = panel.scrollHeight;
        anim = panel.animate(
          [{ height: from + 'px', opacity: from ? 1 : 0 }, { height: to + 'px', opacity: 1 }],
          { duration: this.duration, easing: this.ease }
        );
        anim.onfinish = () => { panel.style.overflow = ''; panel.anim = null; };
        this.revealSteps(panel);
      } else {
        panel.dataset.closing = '1';
        anim = panel.animate(
          [{ height: from + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 250, easing: this.ease }
        );
        anim.onfinish = () => {
          panel.hidden = true;
          panel.style.overflow = '';
          delete panel.dataset.closing;
          panel.anim = null;
        };
      }
      panel.anim = anim;
    }
  }
  if (!customElements.get('skn-tabs')) customElements.define('skn-tabs', SknTabs);

  } catch(e) { console.error(e); }
})();
})();
